module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-22-52-285.c2617097.mp4";